<template>
    <div class="base-rebate" :class="{'rebate-sp': $store.state.screen == 1}">
        <div class="content">
            <div class="header">
                <div class="back-img" @click="$router.back()">
                    <img class="back" src="~images/back.png" />
                </div>
                <div class="title">返利表</div>
                <div class="service-img" @click="$router.push('/base-service')">
                    <img class="ser" src="~images/user_service.png" />
                </div>
            </div>
            <div class="content-auto">
                <div v-if="isblank == true">
                    <div class="title" v-show="gamename">
                        <div class="title-name">{{gamename}}返利表</div>
                    </div>
                    <div class="cen">
                        <div v-html="content"></div>
                    </div>
                </div>
                <div class="theblank" v-if="isblank == false">
                    <TheBlank />
                </div>
            </div>
        </div>
        <!-- <div class="btn" @click="$router.push('/base-rebate-apply')">申请返利</div> -->
    </div>
</template>

<script>
    import TheBlank from '@/components/TheBlank'

    export default {
        name: 'BaseRebate',
        components: {
            TheBlank
        },
        data () {
            return {
                accountData: {},
                content: '',
                gamename: '',
                isblank: null
            }
        },
        methods: {
            // 获取返利表
            getRebate () {
                let options = {
                    appid: this.accountData.appid
                }
                options.sign = this.util.getSign(options, this.accountData.appkey)
                this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=SelfRebate&a=gameRebate', this.$qs.stringify(options)).then(res => {
                    if (res.data.status == 1) {
                        this.content = res.data.data.rebate
                        this.gamename = res.data.data.gamename
                        this.isblank = res.data.data.rebate ? true : false
                        sessionStorage.setItem('setRebate', JSON.stringify(res.data.data))
                    }
                })
            }
        },
        created () {
            this.accountData = JSON.parse(sessionStorage.getItem('accountData'))
            if (sessionStorage.getItem('setRebate')) {
                let setRebate = JSON.parse(sessionStorage.getItem('setRebate'))
                this.content = setRebate.rebate
                this.gamename = setRebate.gamename
                this.isblank = setRebate.rebate ? true : false
            } else {
                this.getRebate()
            }
        }
    }
</script>

<style lang="scss" scoped>
    $color: #FF6C22;
    // 横屏css
    .base-rebate {
        width: 1080px;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        display: flex;
        flex-direction: column;
        transition: all 0.3s;
        .content {
            flex: 1;
            display: flex;
            flex-direction: column;
            overflow-y: scroll;
            .header {
                height: 132px;
                background: rgba($color, 0.8);
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
                .back-img {
                    width: 192px;
                    height: 132px;
                    position: absolute;
                    left: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .back {
                        width: 72px;
                        height: 72px;
                    }
                }
                .title {
                    font-size: 51px;
                    text-align: center;
                }
                .service-img {
                    width: 192px;
                    height: 132px;
                    position: absolute;
                    right: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .ser {
                        width: 72px;
                        height: 72px;
                    }
                }
            }
            .content-auto {
                flex: 1;
                overflow-y: scroll;
                padding: 0 60px;
                position: relative;
                .title {
                    height: 160px;
                    font-size: 45px;
                    border-bottom: 2px solid rgba(255, 255, 255, 0.5);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .title-name {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .cen {
                    font-size: 39px;
                    color: rgba(255, 255, 255, 0.5);
                    padding: 20px 0 50px;
                    overflow: hidden;
                }
                .money {
                    line-height: 100px;
                }
                .theblank {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }
            }
        }
        .btn {
            height: 120px;
            font-size: 39px;
            border-radius: 18px;
            background: $color;
            margin: 0 60px 60px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
    // 竖屏css
    .rebate-sp {
        width: 100%;
        height: 100%;
        .content {
            .header {
                height: 240px;
                border-radius: 60px 0 0 0;
                .back-img {
                    width: 290px;
                    height: 240px;
                    .back {
                        width: 130px;
                        height: 130px;
                    }
                }
                .title {
                    font-size: 92px;
                }
                .service-img {
                    width: 290px;
                    height: 240px;
                    .ser {
                        width: 130px;
                        height: 130px;
                    }
                }
            }
            .content-auto {
                padding: 0 90px;
                .title {
                    height: 290px;
                    font-size: 70px;
                }
                .cen {
                    font-size: 70px;
                    padding: 36px 0 90px;
                }
                .money {
                    line-height: 181px;
                }
            }
        }
        .btn {
            height: 200px;
            font-size: 70px;
            border-radius: 32px;
            margin: 0 90px 90px;
        }
    }
</style>